import RESOURCES from "../../../resourses/RESOURCES";
import { defineStyle } from "@chakra-ui/react";

// Ask a Doubt Styles
export const AskDoubtAccordionStyles = (isSideNav) => {
  return {
    container: defineStyle({
      paddingLeft: "32px",
      gap: "8px",
      display: "flex",
      justifyContent: isSideNav ? "flex-end" : "flex-start",
      alignItems: "center",
      paddingBottom: "12px",
    }),
    vinIcon: defineStyle({
      transform: !isSideNav && "scaleX(-1)",
    }),
    askDoubtBox: defineStyle({
      boxShadow: `0px 4px 4px 0px ${RESOURCES.colors.BOX_SHADOW_BLACK}`,
      borderWidth: "1px",
      borderColor: "grey.200",
      borderRadius: "8px",
      padding: "8px",
      gap: "10px",
      bgColor: "white.900",
      fontFamily: "Poppins, Text-sm/Semibold",
      fontWeight: "600",
      fontSize: "14px",
      lineHeight: "21px",
      color: "black.400",
    }),
  };
};
